<template>
  <div class="gut-check">
    <div class="vx-row mb-4">
      <div class="vx-col mb-4 w-full md:w-1/2">
        <label class="flex mb-2">Age</label>
        <vs-button
          v-for="item in this.$stoolBabyAges"
          v-bind:key="item.id"
          v-model="profile.baby_age"
          color="primary"
          size="small"
          class="mr-4 mb-2"
          :type="profile.baby_age === item.id ? 'filled' : 'border'"
          :disabled="profile.baby_age !== item.id"
        >
          {{ item.title }}
        </vs-button>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <label class="flex mb-2">Food</label>
        <vs-button
          v-for="item in this.$stoolFoodTypes"
          v-bind:key="item.id"
          v-model="profile.food_types"
          color="primary"
          size="small"
          class="mr-4 mb-2"
          :type="profile.food_types.includes(item.id) ? 'filled' : 'border'"
          :disabled="!profile.food_types.includes(item.id)"
        >
          {{ item.title }}
        </vs-button>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <label class="flex mb-2">Frequency</label>
        <vs-button
          v-for="item in this.$stoolFrequencies"
          v-bind:key="item.id"
          v-model="profile.frequency"
          color="primary"
          size="small"
          class="mr-4 mb-2"
          :type="profile.frequency === item.id ? 'filled' : 'border'"
          :disabled="profile.frequency !== item.id"
        >
          {{ item.title }}
        </vs-button>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <label class="flex mb-2">Stool Type</label>
        <vs-button
          v-for="item in this.$stoolConsistencies"
          v-bind:key="item.id"
          v-model="profile.stool_consistency"
          color="primary"
          size="small"
          class="mr-4 mb-2"
          :type="profile.stool_consistency === item.code ? 'filled' : 'border'"
          :disabled="profile.stool_consistency !== item.code"
        >
          {{ item.title }}
        </vs-button>
      </div>

      <div class="vx-col mb-4 w-full">
        <label class="flex mb-2">Stool Color</label>
        <vs-button
          v-for="item in this.$stoolColors"
          v-bind:key="item.id"
          v-model="profile.stool_color"
          color="primary"
          size="small"
          class="mr-4 mb-2"
          :type="profile.stool_color === item.code ? 'filled' : 'border'"
          :disabled="profile.stool_color !== item.code"
        >
          {{ item.title }}
        </vs-button>
      </div>

      <div class="vx-col mb-4 w-full md:w-1/2">
        <label class="flex mb-2">Result</label>
        <vs-button
          v-if="profile.stool_result === 'normal'"
          class="upfc"
          color="success"
          icon-pack="feather"
          icon="icon-check"
          size="large"
        >
          {{ profile.stool_result | capitalize }}
        </vs-button>

        <vs-button
          v-else
          class="upfc"
          color="warning"
          icon-pack="feather"
          icon="icon-alert-triangle"
          size="large"
        >
          {{ profile.stool_result | capitalize }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import schemas from '@/utils/schemas'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StoolTestGut',
  components: {},
  props: {
    locked: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      schema: schemas.stoolTest(),
      profile: schemas.stoolTest(),
      food_type: []
    }
  },
  computed: {
    ...mapGetters('stoolQuestionnaire', {
      $profile: 'profile'
    }),
    ...mapGetters('data', {
      $stoolBabyAges: 'stoolBabyAges',
      $stoolColors: 'stoolColors',
      $stoolConsistencies: 'stoolConsistencies',
      $stoolFoodTypes: 'stoolFoodTypes',
      $stoolFrequencies: 'stoolFrequencies'
    })
  },
  methods: {
    ...mapActions('data', [
      'fetchStoolBabyAges',
      'fetchStoolColors',
      'fetchStoolConsistencies',
      'fetchStoolFoodTypes',
      'fetchStoolFrequencies'
    ])
  },
  async beforeMount() {
    if (this.$stoolBabyAges.length === 0) {
      await this.fetchStoolBabyAges()
    }
    if (this.$stoolColors.length === 0) {
      await this.fetchStoolColors()
    }
    if (this.$stoolFoodTypes.length === 0) {
      await this.fetchStoolFoodTypes()
    }
    if (this.$stoolFrequencies.length === 0) {
      await this.fetchStoolFrequencies()
    }
    if (this.$stoolConsistencies.length === 0) {
      await this.fetchStoolConsistencies()
    }
  },
  mounted() {
    if (this.lodash.isObject(this.$profile)) {
      Object.assign(
        this.profile,
        this.lodash.pick(this.$profile, Object.keys(this.schema))
      )

      if (this.profile.food_types !== null) {
        this.food_type = this.profile.food_types.split(',')
      }
    }
  },
  watch: {
    $profile(to) {
      Object.assign(
        this.profile,
        this.lodash.pick(to, Object.keys(this.schema))
      )
    }
  }
}
</script>

<style scoped>
.th-top th {
  background: #b3b3b3;
}

.th-sub th {
  background: #efefef;
}

.td-gut .con-vs-chip {
  float: none;
  width: 30px;
  margin: 10px auto;
}

.bg-normal {
  background-color: rgba(40, 199, 111, 0.1);
}

.bg-abnormal {
  background-color: rgba(255, 159, 67, 0.1);
}

.td {
  background: pink;
}

th,
td {
  text-align: center;
  padding: 10px;
  width: 11%;
}
</style>
